const name = "paguelofacilCore";

function hex_to_ascii(str) {
    const hexString = str;
    let strOut = '';
    for (let x = 0; x < hexString.length; x += 2) {
        strOut += String.fromCharCode(parseInt(hexString.substr(x, 2), 16));
    }
    return strOut;
}

export const ascii_to_hex = (str) => {
    let hex;
    try {
        hex = unescape(encodeURIComponent(str))
            .split("")
            .map(function (v) {
                return v.charCodeAt(0).toString(16);
            })
            .join("");
    } catch (e) {
        hex = str;
    }
    return hex;
};

function IsJsonString(str) {
    try {
        JSON.parse(JSON.stringify(str));
    } catch (e) {
        return false;
    }
    return true;
}

function encode(_str) {
    let str = _str;
    if (IsJsonString(_str)) {
        str = JSON.stringify(_str);
    }
    return ascii_to_hex(btoa(str));
}

function decode(_str) {
    return decodeBase64(hex_to_ascii(_str));
}
function decodeBase64(str) {
    return UTF8ArrToStr(base64DecToArr(str));
}

function UTF8ArrToStr(aBytes) {
    var sView = "";

    for (var nPart, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
        nPart = aBytes[nIdx];
        sView += String.fromCharCode(
            nPart > 251 && nPart < 254 && nIdx + 5 < nLen /* six bytes */
                ? /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
                (nPart - 252) * 1073741824 +
                ((aBytes[++nIdx] - 128) << 24) +
                ((aBytes[++nIdx] - 128) << 18) +
                ((aBytes[++nIdx] - 128) << 12) +
                ((aBytes[++nIdx] - 128) << 6) +
                aBytes[++nIdx] -
                128
                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen /* five bytes */
                    ? ((nPart - 248) << 24) +
                    ((aBytes[++nIdx] - 128) << 18) +
                    ((aBytes[++nIdx] - 128) << 12) +
                    ((aBytes[++nIdx] - 128) << 6) +
                    aBytes[++nIdx] -
                    128
                    : nPart > 239 && nPart < 248 && nIdx + 3 < nLen /* four bytes */
                        ? ((nPart - 240) << 18) + ((aBytes[++nIdx] - 128) << 12) + ((aBytes[++nIdx] - 128) << 6) + aBytes[++nIdx] - 128
                        : nPart > 223 && nPart < 240 && nIdx + 2 < nLen /* three bytes */
                            ? ((nPart - 224) << 12) + ((aBytes[++nIdx] - 128) << 6) + aBytes[++nIdx] - 128
                            : nPart > 191 && nPart < 224 && nIdx + 1 < nLen /* two bytes */
                                ? ((nPart - 192) << 6) + aBytes[++nIdx] - 128
                                : /* nPart < 127 ? */ /* one byte */
                                nPart,
        );
    }

    return sView;
}

function base64DecToArr(sBase64, nBlocksSize) {
    var sB64Enc = sBase64.replace(/[^A-Za-z0-9+/]/g, ""),
        nInLen = sB64Enc.length,
        nOutLen = nBlocksSize ? Math.ceil(((nInLen * 3 + 1) >> 2) / nBlocksSize) * nBlocksSize : (nInLen * 3 + 1) >> 2,
        taBytes = new Uint8Array(nOutLen);

    for (var nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
        nMod4 = nInIdx & 3;
        nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << (18 - 6 * nMod4);
        if (nMod4 === 3 || nInLen - nInIdx === 1) {
            for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
                taBytes[nOutIdx] = (nUint24 >>> ((16 >>> nMod3) & 24)) & 255;
            }
            nUint24 = 0;
        }
    }

    return taBytes;
}
function b64ToUint6(nChr) {
    return nChr > 64 && nChr < 91
        ? nChr - 65
        : nChr > 96 && nChr < 123
            ? nChr - 71
            : nChr > 47 && nChr < 58
                ? nChr + 4
                : nChr === 43
                    ? 62
                    : nChr === 47
                        ? 63
                        : 0;
}

function encodeHex(_str) {
    let str = _str;
    if (IsJsonString(_str)) {
        str = JSON.stringify(_str);
    }
    return ascii_to_hex(str);
}


export const getNamesUser = (name) => {
    try {
        const fullname = name.trim().split(" ");

        let firstname = "";
        let lastname = "";

        if (fullname.length === 4) {
            firstname = fullname[0] + " " + fullname[1];
            lastname = fullname[2] + " " + fullname[3];
        }
        if (fullname.length === 3) {
            firstname = fullname[0];
            lastname = fullname[1] + " " + fullname[2];
        }
        if (fullname.length === 2) {
            firstname = fullname[0];
            lastname = fullname[1];
        }

        return { firstname, lastname };
    } catch (e) {
        return { firstname: "", lastname: "" };
    }
};

// https://stackoverflow.com/a/2998874/1673761
export const twoDigits = (num) => String(num).padStart(2, "0");

export const cryptoUtil = { name, encode, decode, encodeHex, getNamesUser, twoDigits };